import React, {Component} from 'react';
import {Link, withRouteData} from 'react-static';
import styled from 'styled-components';

import FBFLogo from '../resources/images/fbflogo.png';

const FBFStyle = styled.div`
	margin-bottom: 6.25rem;
	
	h2 {
	    font-weight: 500;
	    font-size: 2.5rem;
	    line-height: 1.25em;
	}
	
	img {
		margin-bottom: 0.5rem;
		height: 120px;
		@media screen and (max-width: 39.9375em) {
			height: 80px;
		}
	}
`;

class FBF extends Component {

	render() {
		return (
			<FBFStyle>
				<div className="container">
					<div className="row">
						<div className="columns small-12 medium-centered text-center">
							<h2>{this.props.cover.fbf}</h2>
							<a href="https://firstblockchain.fund/business-invite/an0kphtdmoyt2opxe" rel="noopener noreferrer">
								<img src={FBFLogo} alt="First Blockchain Fund Logo"/>
							</a>
							<h3>First Blockchain Fund</h3>
						</div>
					</div>
				</div>
			</FBFStyle>
		)
	}
}

export default withRouteData(FBF)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/FBF.js